module.exports = __webpack_public_path__ + "img/xiaolv.ce8a035a.png";